// src/components/home/DictionaryCarousel.jsx

import React from 'react';
import { ChevronRight, BookOpen } from 'lucide-react';

const POPULAR_TERMS = [
  {
    id: 'fail',
    arabic: 'فَاعِلٌ',
    title: "Fa'il",
    desc: 'Pelaku / Subjek',
    gradient: 'from-emerald-400 to-emerald-600',
    bgColor: 'bg-emerald-50 dark:bg-emerald-900/20',
    borderColor: 'border-emerald-200 dark:border-emerald-800/40',
    textColor: 'text-emerald-700 dark:text-emerald-300',
    countBg: 'bg-emerald-500',
  },
  {
    id: 'maful',
    arabic: 'مَفْعُولٌ',
    title: "Maf'ul Bih",
    desc: 'Objek Penderita',
    gradient: 'from-sky-400 to-sky-600',
    bgColor: 'bg-sky-50 dark:bg-sky-900/20',
    borderColor: 'border-sky-200 dark:border-sky-800/40',
    textColor: 'text-sky-700 dark:text-sky-300',
    countBg: 'bg-sky-500',
  },
  {
    id: 'mubtada',
    arabic: 'مُبْتَدَأٌ',
    title: "Mubtada'",
    desc: 'Pokok Kalimat',
    gradient: 'from-purple-400 to-purple-600',
    bgColor: 'bg-purple-50 dark:bg-purple-900/20',
    borderColor: 'border-purple-200 dark:border-purple-800/40',
    textColor: 'text-purple-700 dark:text-purple-300',
    countBg: 'bg-purple-500',
  },
  {
    id: 'khabar',
    arabic: 'خَبَرٌ',
    title: 'Khabar',
    desc: 'Penjelas Mubtada',
    gradient: 'from-orange-400 to-orange-600',
    bgColor: 'bg-orange-50 dark:bg-orange-900/20',
    borderColor: 'border-orange-200 dark:border-orange-800/40',
    textColor: 'text-orange-700 dark:text-orange-300',
    countBg: 'bg-orange-500',
  },
  {
    id: 'fiil',
    arabic: 'فِعْلٌ',
    title: "Fi'il",
    desc: 'Kata Kerja',
    gradient: 'from-teal-400 to-teal-600',
    bgColor: 'bg-teal-50 dark:bg-teal-900/20',
    borderColor: 'border-teal-200 dark:border-teal-800/40',
    textColor: 'text-teal-700 dark:text-teal-300',
    countBg: 'bg-teal-500',
  },
  {
    id: 'isim',
    arabic: 'اِسْمٌ',
    title: 'Isim',
    desc: 'Kata Benda',
    gradient: 'from-pink-400 to-pink-600',
    bgColor: 'bg-pink-50 dark:bg-pink-900/20',
    borderColor: 'border-pink-200 dark:border-pink-800/40',
    textColor: 'text-pink-700 dark:text-pink-300',
    countBg: 'bg-pink-500',
  },
];

export default function DictionaryCarousel({ onViewAll, onTermClick }) {
  return (
    <div
      className="px-4 mb-2 animate-fade-in"
      style={{ animationDelay: '0.2s' }}
    >
      {/* ── Section Header ─────────────────────────── */}
      <div className="flex items-center justify-between mb-3">
        <div className="flex items-center gap-2">
          <BookOpen className="w-4 h-4 text-green-600 dark:text-green-400" />
          <h2 className="text-sm font-extrabold text-slate-800 dark:text-slate-100">
            Istilah Populer
          </h2>
        </div>
        <button
          onClick={onViewAll}
          className="
            flex items-center gap-1
            text-[11px] font-bold
            text-green-600 dark:text-green-400
            hover:text-green-700 dark:hover:text-green-300
            transition-colors
          "
        >
          <span>Lihat Semua</span>
          <ChevronRight className="w-3.5 h-3.5" />
        </button>
      </div>

      {/* 
        ── Grid 3 Kolom (sama seperti CategoryGrid) ──
        Konsisten dengan tampilan kategori di halaman Kamus
      */}
      <div className="grid grid-cols-3 gap-2.5">
        {POPULAR_TERMS.map((term, index) => (
          <button
            key={term.id}
            onClick={() => onTermClick?.(term.id)}
            className={`
              ${term.bgColor} ${term.borderColor}
              border rounded-3xl p-3
              flex flex-col items-start
              hover:scale-[1.04] active:scale-[0.96]
              transition-all duration-200
              shadow-soft
              animate-scale-in
              text-left
            `}
            style={{ animationDelay: `${0.2 + index * 0.06}s` }}
          >
            {/* Atas: Ikon Gradien */}
            <div
              className={`
                w-10 h-10 rounded-2xl mb-2.5
                bg-gradient-to-br ${term.gradient}
                flex items-center justify-center
                shadow-md
              `}
            >
              {/* Teks Arab kecil di dalam ikon */}
              <span
                dir="rtl"
                className="text-white font-bold leading-none"
                style={{ fontFamily: 'Amiri, serif', fontSize: '16px' }}
              >
                {/* Ambil huruf pertama dari kata Arab */}
                {term.arabic.charAt(0)}
              </span>
            </div>

            {/* Teks Arab Lengkap */}
            <p
              dir="rtl"
              className={`text-lg font-bold ${term.textColor} mb-1 leading-tight w-full text-right`}
              style={{ fontFamily: 'Amiri, serif' }}
            >
              {term.arabic}
            </p>

            {/* Judul Latin */}
            <p className="text-[11px] font-extrabold text-slate-700 dark:text-slate-200 leading-tight mb-0.5">
              {term.title}
            </p>

            {/* Deskripsi */}
            <p className="text-[10px] text-slate-400 dark:text-slate-500 leading-tight">
              {term.desc}
            </p>
          </button>
        ))}
      </div>

    </div>
  );
}